<template>
  <div>
    <router-view :key="moduleKey" v-if="moduleIsReady"/>
    <div v-else>Loading Data...</div>
  </div>
</template>

<script>

export default {
  name: 'SitesModule',

  created() {
    // this.bootstrap();
  },
  date() {
    return {
      // isRead: false,
      // mySites: this.$store.getters.mySites,
    };
  },
  computed: {
    // mySites() {
    //   return this.$store.getters.mySites;
    // },

    moduleIsReady() {
      return true; // !!this.mySites; // !!this.users;
    },

    moduleKey() {
      return 'sites';
    },
  },
  watch: {
    // mySites() {
    //   this.isRead = !!this.mySites;
    // },
  },
};
</script>

<style>
.pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
